import PropTypes from 'prop-types';
import { Box, Grid2, Stack, Typography } from '@mui/material';

import { HEADER_HEIGHT, HEADER_HEIGHT_MOBILE } from 'constants/components';
import { useBreakpointFlags } from 'hooks/useBreakpointFlags';
import FullScreenLoader from 'layouts/FullScreenLoader';
import background from 'assets/img/login-background.png';
import { Logo } from 'assets/icons';

import ContentContainer from './ContentContainer';

const styles = {
  wrapper: (headerHeight) => ({
    height: '100vh',
    position: 'relative',
    paddingTop: `${headerHeight}px`,
  }),
  bgContainer: (headerHeight) => ({
    width: '100%',
    height: `calc(100vh - ${headerHeight}px)`,
    position: 'fixed',
    top: headerHeight,
    left: 0,
  }),
  container: {
    position: 'relative',
    zIndex: 1,
    height: '100%',
  },
  bgStyles: {
    height: '100%',
    backgroundImage: `url(${background})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    padding: 2,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  content: {
    width: '100%',
    maxWidth: 630,
  },
  text: {
    fontSize: '100px !important',
    fontWeight: 700,
  },
  logo: {
    width: 255,
    svg: {
      width: '100%',
      height: '100%',
    },
  },
};

const AuthContainer = ({ text, withLogo = false, isBackgroundFirst = false, isLoading = false, children }) => {
  const { isLgUp: isDesktop } = useBreakpointFlags();
  const headerHeight = isDesktop ? HEADER_HEIGHT : HEADER_HEIGHT_MOBILE;

  if (isLoading) {
    return <FullScreenLoader />;
  }

  return (
    <Box sx={styles.wrapper(headerHeight)}>
      <Grid2 container direction={isBackgroundFirst ? 'row-reverse' : 'row'} sx={styles.bgContainer(headerHeight)}>
        <ContentContainer />

        {isDesktop && (
          <Grid2 size={{ lg: 6, xl: 7 }}>
            <Box sx={styles.bgStyles}>
              <Stack spacing={3} sx={styles.content}>
                <Typography variant="h1" component="p" color="text.secondary" sx={styles.text}>
                  {text}
                </Typography>

                {withLogo && (
                  <Box sx={styles.logo}>
                    <Logo />
                  </Box>
                )}
              </Stack>
            </Box>
          </Grid2>
        )}
      </Grid2>

      <Grid2 container direction={isBackgroundFirst ? 'row-reverse' : 'row'} sx={styles.container}>
        <ContentContainer>{children}</ContentContainer>
      </Grid2>
    </Box>
  );
};

AuthContainer.propTypes = {
  text: PropTypes.string.isRequired,
  withLogo: PropTypes.bool,
  isBackgroundFirst: PropTypes.bool,
  isLoading: PropTypes.bool,
  children: PropTypes.node.isRequired,
};
export default AuthContainer;
